export default "__VITE_ASSET__DXA32YT4__"